<template>
      <div class="product-details d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="d-flex align-items-center gap-3 p-3 bg-primary">
            <a href="index.html" class="text-white"><i class="bi bi-arrow-left fs-5"></i></a>
            <div>
               <h6 class="fw-bold text-white mb-0">Uncle Chips</h6>
               <p class="text-white-50 small m-0">Foodmart</p>
            </div>
            <div class="d-flex align-items-center gap-2 ms-auto">
               <a href="profile.html" class="link-dark">
                  <div class="bg-dark bg-opacity-75 rounded-circle user-icon"><i class="bi bi-person d-flex m-0 h4 text-white"></i></div>
               </a>
               <a class="toggle hc-nav-trigger hc-nav-1" href="#" role="button" aria-controls="hc-nav-1">
               <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
               <i class="bi bi-list d-flex m-0 h4 text-white"></i>
               </b>
               </a>
            </div>
         </div>
         <!-- slider -->
         <div class="vh-100 my-auto overflow-auto">
            <div class="bg-white shadow-sm p-3 mb-3">
               <div class="product-slider">
                  <div class="product-item">
                     <img src="img/product-detail-1.png" alt="" class="img-fluid mx-auto">
                  </div>
                  <div class="product-item">
                     <img src="img/product-detail-2.png" alt="" class="img-fluid mx-auto">
                  </div>
                  <div class="product-item">
                     <img src="img/product-detail-3.png" alt="" class="img-fluid mx-auto">
                  </div>
               </div>
               <!-- detail -->
               <div class="pt-4">
                  <p class="text-primary mb-1">Uncle Chips</p>
                  <h5 class="fw-bold text-black lh-base">Uncle Chipps Potato Chips - Plain Salted Flavour, Crispy Snacks, 50 g Pouch
                  </h5>
               </div>
               <div class="d-flex align-items-center justify-content-between">
                  <div class="mb-0">
                     <p class="text-muted mb-1">50 g</p>
                     <h6 class="mb-0">$20 <small>(Inclusive of all taxes)</small></h6>
                  </div>
                  <div>
                  </div>
               </div>
            </div>
            <!-- important information -->
            <div class="bg-white shadow-sm p-3">
               <h6 class="fw-bold mb-2">Important Information</h6>
               <p class="text-muted m-0">Treat yourself to some delicious, crunchy, perfectly salted chips! Uncle Chipps is undeniably everyone’s favourite! For years, they have been around and have been a constant source of fun and pleasant memories. Made from the best quality potatoes and simply seasoned with salt, Uncle Chipps are a flavorful delight! Enjoy watching your favourite programs with a bag of Uncle Chipps or have this delicious treat on your quick work break. These chips are just perfect to snack on and their irresistible flavour makes them the ideal go-to treat.
               </p>
            </div>
         </div>
         <div class="mt-auto bg-white p-3">
            <a href="cart.html" class="btn btn-success w-100 text-uppercase btn-lg fw-bold">ADD TO CART</a>
         </div>
      </div>
      <!-- sidebar nav -->
    
</template>